import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { StickyNav } from "@/components/site/StickyNav";
import { Hero } from "@/components/site/Hero";
import { ValueGrid } from "@/components/site/ValueGrid";
import { Spotlight } from "@/components/site/Spotlight";
import { DumpTrailer } from "@/components/site/DumpTrailer";
import { Reviews } from "@/components/site/Reviews";
import { ServiceMap } from "@/components/site/ServiceMap";
import { DispatchForm } from "@/components/site/DispatchForm";
import { PartnerBar } from "@/components/site/PartnerBar";
import { SiteFooter } from "@/components/site/SiteFooter";

export default function TwiztedTow() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <main data-testid="twizted-tow-page" className="tt-noise relative bg-[var(--tt-black)] text-white">
      <StickyNav />
      <Hero />
      <ValueGrid />
      <Spotlight />
      <DumpTrailer />
      <Reviews />
      <ServiceMap />
      <DispatchForm />
      <PartnerBar />
      <SiteFooter />
      <Toaster position="top-center" theme="dark" richColors />
    </main>
  );
}
